import { useBootstrap } from './useBootstrap';
import { useAuthChanged } from './useAuthChanged';
import { useProfileChanged } from './useProfileChanged';
import { useAppConfigurationChanged } from './useAppConfigurationChanged';
import { useAppFlow } from './useAppFlow';
import { useArticleInIframe } from './useArticleInIframe';

export const useAppLogic = () => {
  useBootstrap();
  useAuthChanged();
  useProfileChanged();
  useAppConfigurationChanged();
  useAppFlow();
  useArticleInIframe();
};
